import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'routing-servers',
  templateUrl: './routing-servers.component.html',
  styleUrls: ['./routing-servers.component.scss']
})
export class RoutingServersComponent implements OnInit {

  routingServersItems;

  constructor() {
    this.routingServersItems = [
      {routerLink: 'servers', name: 'Servers'},
      {routerLink: 'groups', name: 'Groups'}
    ];
  }

  ngOnInit(): void {
  }

}
